import SvgIcon from '@mui/material/SvgIcon';

import type { SvgIconProps } from '@mui/material';

export const RedCrossIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} fill="none" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.57186 1.21484L13 10.6425L22.428 1.21484C23.0789 0.563966 24.1342 0.563966 24.7851 1.21484C25.4359 1.86571 25.4359 2.92099 24.7851 3.57186L15.3575 13L24.7851 22.428C25.4359 23.0789 25.4359 24.1342 24.7851 24.7851C24.1342 25.4359 23.0789 25.4359 22.428 24.7851L13 15.3575L3.57186 24.7851C2.92099 25.4359 1.86571 25.4359 1.21484 24.7851C0.563966 24.1342 0.563966 23.0789 1.21484 22.428L10.6425 13L1.21484 3.57186C0.563966 2.92099 0.563966 1.86571 1.21484 1.21484C1.86571 0.563966 2.92099 0.563966 3.57186 1.21484Z" fill={props.fill ? props.fill : '#F91F44'} />
    </SvgIcon>
);
